import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 5,
    },
    detailContainer: {
        width: '99%',
        minWidth: '270px',
        margin: '0 10px',
        '& div': {
            backgroundColor: 'white',
            padding: '22px 10px 10px 22px',
        },
        '& p': {
            fontSize: 15,
            fontWeight: 'bold',
            color: theme.palette.primary.dark,
            margin: '0',
        },
        '& ul': {
            padding: 0,
            margin: '10px 20px',
            fontWeight: '300',
        },
        '& li': {
            fontSize: 15,
            color: theme.palette.primary.dark,
            lineHeight: 1.5,
        },
    },
    header: {
        position: 'relative',
        cursor: 'pointer',
        width: '100%',
        display: 'flex',
        marginBottom: 15,
        '& div': {
            margin: 0,
            '& div:nth-child(1)': {
                color: theme.palette.primary.dark,
                display: 'inline-block',
                fontSize: 15,
                fontWeight: 300,
            },
            '& div:nth-child(2)': {
                color: theme.palette.primary.light,
                display: 'inline-block',
                fontSize: 15,
                fontWeight: 300,
            },
        },
    },
    closeIcon: {
        position: 'absolute',
        fontSize: 20,
        top: 5,
        right: 1,
        stroke: 'currentColor',
        transform: 'rotate(45deg)',
    },
    downIcon: {
        position: 'absolute',
        right: 1,
        stroke: 'currentColor',
        transform: 'rotate(90deg)',
    },
}));
